module.exports = __webpack_public_path__ + "static/media/appstore_new.b4c070d8.svg";